const i18nData = {
  en: {
    k001: 'Earn up to 20% commission! 🚀',
    k002: 'Code:',
    k006: 'Start your own agency with zero cost. Invite hostesses and sub-agents to enjoy passive income.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copy',
    copied: 'Copied',
    nicknameFallback: '[Nickname]',
  },
  ar: {
    k001: 'اربحي عمولة تصل إلى 20%! 🚀',
    k002: 'الرمز:',
    k006: 'ابدئي وكالتك الخاصة بدون تكلفة. ادعي المضيفات والوكلاء الفرعيين للاستمتاع بدخل سلبي.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'نسخ',
    copied: 'منسوخ',
    nicknameFallback: '[الاسم]',
  },
  az: {
    k001: '20%-ə qədər komissiya qazanın! 🚀',
    k002: 'Kod:',
    k006: 'Sıfır xərclə öz agentliyinizi başladın. Passiv gəlir üçün aparıcıları və sub-agentləri dəvət edin.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopyala',
    copied: 'Kopyalandı',
    nicknameFallback: '[Nickname]',
  },
  bn: {
    k001: '২০% পর্যন্ত কমিশন উপার্জন করুন! 🚀',
    k002: 'কোড:',
    k006: 'শূন্য খরচে নিজের এজেন্সি শুরু করুন। প্যাসিভ আয় উপভোগ করতে হোস্টেস ও সাব-এজেন্টদের আমন্ত্রণ জানান।',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'কপি',
    copied: 'কপি হয়েছে',
    nicknameFallback: '[Nickname]',
  },
  da: {
    k001: 'Tjen op til 20% kommission! 🚀',
    k002: 'Kode:',
    k006: 'Start dit eget bureau uden omkostninger. Inviter værter og underagenter for at nyde passiv indkomst.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopi',
    copied: 'Kopieret',
    nicknameFallback: '[Nickname]',
  },
  de: {
    k001: 'Verdiene bis zu 20% Provision! 🚀',
    k002: 'Code:',
    k006: 'Starte deine eigene Agentur ohne Kosten. Lade Hostessen und Sub-Agenten ein und genieße passives Einkommen.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopieren',
    copied: 'Kopiert',
    nicknameFallback: '[Nickname]',
  },
  es: {
    k001: '¡Gana hasta un 20% de comisión! 🚀',
    k002: 'Código:',
    k006: 'Inicia tu propia agencia sin costo. Invita anfitrionas y sub-agentes para disfrutar de ingresos pasivos.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copiar',
    copied: 'Copiado',
    nicknameFallback: '[Nickname]',
  },
  fa: {
    k001: 'تا ۲۰٪ کمیسیون کسب کنید! 🚀',
    k002: 'کد:',
    k006: 'آژانس خود را بدون هزینه راه‌اندازی کنید. میزبان‌ها و زیرنماینده‌ها را دعوت کنید و از درآمد غیرفعال لذت ببرید.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'کپی',
    copied: 'کپی شد',
    nicknameFallback: '[Nickname]',
  },
  fr: {
    k001: "Gagnez jusqu'à 20 % de commission ! 🚀",
    k002: 'Code :',
    k006: "Lancez votre propre agence sans frais. Invitez des hôtesses et des sous-agents pour profiter d'un revenu passif.",
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copier',
    copied: 'Copié',
    nicknameFallback: '[Nickname]',
  },
  he: {
    k001: 'הרוויחי עד 20% עמלה! 🚀',
    k002: 'קוד:',
    k006: 'הקימי סוכנות משלך ללא עלות. הזמיני מנחות וסוכני משנה כדי ליהנות מהכנסה פסיבית.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'העתק',
    copied: 'הועתק',
    nicknameFallback: '[Nickname]',
  },
  id: {
    k001: 'Dapatkan komisi hingga 20%! 🚀',
    k002: 'Kode:',
    k006: 'Mulai agensi sendiri tanpa biaya. Undang hostess dan sub-agent untuk menikmati penghasilan pasif.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'salin',
    copied: 'Disalin',
    nicknameFallback: '[Nickname]',
  },
  it: {
    k001: 'Guadagna fino al 20% di commissione! 🚀',
    k002: 'Codice:',
    k006: 'Avvia la tua agenzia a costo zero. Invita hostess e sub-agent per godere di un reddito passivo.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copia',
    copied: 'Copiato',
    nicknameFallback: '[Nickname]',
  },
  ms: {
    k001: 'Peroleh komisen sehingga 20%! 🚀',
    k002: 'Kod:',
    k006: 'Mulakan agensi anda sendiri tanpa kos. Jemput hos dan sub-ejen untuk menikmati pendapatan pasif.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'salin',
    copied: 'Disalin',
    nicknameFallback: '[Nickname]',
  },
  pl: {
    k001: 'Zarabiaj do 20% prowizji! 🚀',
    k002: 'Kod:',
    k006: 'Załóż własną agencję bez kosztów. Zapraszaj hostessy i sub-agentów, aby cieszyć się pasywnym dochodem.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopiuj',
    copied: 'Skopiowano',
    nicknameFallback: '[Nickname]',
  },
  pt: {
    k001: 'Ganhe até 20% de comissão! 🚀',
    k002: 'Código:',
    k006: 'Comece sua própria agência sem custo. Convide anfitriãs e sub-agentes para aproveitar renda passiva.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copiar',
    copied: 'Copiado',
    nicknameFallback: '[Nickname]',
  },
  ro: {
    k001: 'Câștigă până la 20% comision! 🚀',
    k002: 'Cod:',
    k006: 'Pornește propria agenție fără costuri. Invită gazde și sub-agenți pentru venit pasiv.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copiază',
    copied: 'Copiat',
    nicknameFallback: '[Nickname]',
  },
  ru: {
    k001: 'Зарабатывайте до 20% комиссии! 🚀',
    k002: 'Код:',
    k006: 'Откройте своё агентство без затрат. Приглашайте ведущих и суб-агентов для пассивного дохода.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'копировать',
    copied: 'Скопировано',
    nicknameFallback: '[Nickname]',
  },
  th: {
    k001: 'รับค่าคอมมิชชั่นสูงสุด 20%! 🚀',
    k002: 'รหัส:',
    k006: 'เริ่มเอเจนซี่ของคุณโดยไม่มีค่าใช้จ่าย เชิญโฮสเตสและซับเอเจนต์เพื่อรายได้แบบพาสซีฟ',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    nicknameFallback: '[Nickname]',
  },
  tr: {
    k001: "%20'ye kadar komisyon kazan! 🚀",
    k002: 'Kod:',
    k006: 'Sıfır maliyetle kendi ajansını kur. Pasif gelir için sunucuları ve alt acenteleri davet et.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopyala',
    copied: 'Kopyalandı',
    nicknameFallback: '[Nickname]',
  },
  uk: {
    k001: 'Заробляйте до 20% комісії! 🚀',
    k002: 'Код:',
    k006: 'Відкрийте власне агентство без витрат. Запрошуйте ведучих і суб-агентів для пасивного доходу.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'копіювати',
    copied: 'Скопійовано',
    nicknameFallback: '[Nickname]',
  },
  vi: {
    k001: 'Kiếm hoa hồng lên đến 20%! 🚀',
    k002: 'Mã:',
    k006: 'Khởi nghiệp agency không tốn phí. Mời hostess và sub-agent để hưởng thu nhập thụ động.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'sao chép',
    copied: 'Đã sao chép',
    nicknameFallback: '[Nickname]',
  },
}

const rtlLangs = { ar: true, fa: true, he: true }

export default {
  data() {
    return {
      t: {},
      isRtl: false,
    }
  },
  created() {
    const query = this.$route.query || {}
    const lang = i18nData[query.lang] ? query.lang : 'en'
    this.t = i18nData[lang]
    this.isRtl = !!rtlLangs[lang]
  },
}
